import type { Cin7Customer } from "@/api/dtos";
import type { Customer } from "@/api/customer/_models/Customer";
import {
  tagsFromCin7,
  toCustomerAddressFromCin7CustomerAddress,
  toCustomerChildFromCin7CustomerChild,
  toCustomerContactFromCin7CustomerContact,
} from "./utils";

export const toCustomerFromCin7Customer = (dto: Cin7Customer): Customer => {
  return {
    id: dto.ID,
    name: dto.Name,
    displayName: dto.DisplayName,
    currency: dto.Currency,
    paymentTerm: dto.PaymentTerm,
    discount: dto.Discount,
    taxRule: dto.TaxRule,
    carrier: dto.Carrier,
    salesRepresentative: dto.SalesRepresentative,
    location: dto.Location,
    comments: dto.Comments,
    accountReceivable: dto.AccountReceivable,
    revenueAccount: dto.RevenueAccount,
    priceTier: dto.PriceTier,
    taxNumber: dto.TaxNumber,
    attributeSet: dto.AttributeSet,
    tags: tagsFromCin7(dto.Tags),
    status: dto.Status,
    creditLimit: dto.CreditLimit,
    isOnCreditHold: dto.IsOnCreditHold,
    isLegalEntity: dto.IsLegalEntity,
    parentId: dto.CustomerParentID,
    parentName: dto.CustomerParentName,
    isBillParent: dto.IsBillParent,
    lastModifiedOn: dto.LastModifiedOn,
    addresses: dto.Addresses.map((x) => toCustomerAddressFromCin7CustomerAddress(x)),
    contacts: dto.Contacts.map((x) => toCustomerContactFromCin7CustomerContact(x)),
    childCustomers: dto.ChildCustomers.map((x) => toCustomerChildFromCin7CustomerChild(x)),
  };
};
